import React from "react";
import logo from "../assets/logo.png";

const Footer: React.FC = () => {
  return (
    <footer className="relative z-10">
      <div className="w-full mb-2  flex flex-col md:flex-row justify-between items-center px-4 sm:px-6 lg:px-44 py-2 space-y-2 sm:space-y-0">
        {/* Left: contact info */}
        <div className="flex flex-wrap justify-center md:justify-start gap-2 md:gap-3">
          <a
            href="mailto:kontakt@directpress.pl"
            className="text-slate-600 text-xs sm:text-sm hover:underline"
          >
            kontakt@directpress.pl
          </a>
          <a
            href="tel:+48666657366"
            className="text-slate-600 text-xs sm:text-sm hover:underline"
          >
            +48 666 657 366
          </a>
          <span className="text-slate-600 text-xs sm:text-sm">
            ul. Hoża 86/410, 00-682 Warszawa
          </span>
        </div>

        {/* Right: copyright */}

        <div className="flex items-center gap-8">
          <img src={logo} alt="Logo" className="h-8 w-auto sm:h-10" />
          <p className="text-slate-600 text-xs sm:text-sm text-right">
            © {new Date().getFullYear()} DIRECT PRESS Sp. z o.o.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
